import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const videos = [
  { src: '/assets/file 1.mp4', title: 'Campaign Strategy Video', description: 'Strategic planning and execution showcase', icon: '🎥' },
  { src: '/assets/file 2.mp4', title: 'Digital Outreach Reel', description: 'Connecting with voters online', icon: '📱' },
  { src: '/assets/file 3.mp4', title: 'Rally Highlights', description: 'Capturing the energy of the campaign trail', icon: '🎤' },
  { src: '/assets/file 4.mp4', title: 'Candidate Biography', description: 'Telling the story of your candidate', icon: '👤' },
  { src: '/assets/file 4.mp4', title: 'Candidate Biography', description: 'Telling the story of your candidate', icon: '👤' },
  { src: '/assets/file 4.mp4', title: 'Candidate Biography', description: 'Telling the story of your candidate', icon: '👤' },
];

const images = [
  '/politicalGraphics/1.jpg',
  '/politicalGraphics/2.jpg',
  '/politicalGraphics/3.jpg',
  '/politicalGraphics/4.jpg',
  '/politicalGraphics/5.jpg',
  '/politicalGraphics/6.jpg',
  '/politicalGraphics/7.jpg',
  '/politicalGraphics/8.jpg',

];




const videoVariants = {
  enter: {
    x: '100%',
    opacity: 0,
  },
  center: {
    x: 0,
    opacity: 1,
  },
  exit: {
    x: '-100%',
    opacity: 0,
  },
};


import './PortfolioPage.css';


const PortfolioPage = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRef = useRef(null);

  const handleVideoEnded = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1));
  };

  const getVisibleVideos = () => {
    const visibleVideos = [];
    for (let i = -2; i <= 2; i++) {
      const index = (activeIndex + i + videos.length) % videos.length;
      visibleVideos.push(videos[index]);
    }
    return visibleVideos;
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => console.error("Error attempting to play video:", error));
    }
  }, [activeIndex]);

  return (
    <div className="bg-gray-100 py-12 md:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
            Our Portfolio
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Check out some of our work below. We have experience creating a wide variety of content for political campaigns.
          </p>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Videos</h3>
          <div className="video-carousel-container">
            <div className="video-carousel">
              <AnimatePresence>
                {getVisibleVideos().map((video, index) => (
                  <motion.div
                    key={activeIndex + index}
                    className={`video-item-wrapper ${index === 2 ? 'active' : ''}`}
                    initial={{ x: (index - 2) * 220, opacity: 0, scale: 0.8 }}
                    animate={{ x: (index - 2) * 220, opacity: 1, scale: index === 2 ? 1.2 : 0.8 }}
                    exit={{ x: (index - 2) * 220 - 220, opacity: 10, scale: 0.8 }}
                    transition={{ type: 'spring', stiffness: 100, damping: 20 }}
                  >
                    <div className={`video-item ${index === 2 ? 'mobile-frame' : ''}`}>
                      <video
                        ref={index === 2 ? videoRef : null}
                        src={video.src}
                        muted
                        onEnded={index === 2 ? handleVideoEnded : null}
                        playsInline
                        preload="metadata"
                        autoPlay={index === 2}
                      />
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
          </div>
        </div>

        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Samples Graphics </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {images.map((image, index) => (
              <div key={index} className="rounded-lg shadow-lg overflow-hidden">
                <img src={image} alt={`Portfolio image ${index + 1}`} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;
